<div class="app-shell">
    <app-menu-left-v2></app-menu-left-v2>

    <div class="cat__content">
        <router-outlet></router-outlet>
        <app-footer></app-footer>
    </div>
</div>